/*
 * @Author: your name
 * @Date: 2020-11-24 17:16:04
 * @LastEditTime: 2021-04-22 18:19:35
 * @LastEditors: JDY
 * @Description: In User Settings Edit
 * @FilePath: \new_if_admind:\phpstudy_pro\WWW\lfadmin\src\api\api.js
 */
import request from '@/utils/request'
/**
 * put func
 * parameter: {}
 * @param parameter
 * @returns {*}
 */
export function requestPut (url, parameter = {}) {
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'put',
            data: parameter
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}
/**
 * delete func
 * parameter: {}
 * @param parameter
 * @returns {*}
 */
export function requestPatch (url) {
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'patch'
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}
/**
 * delete func
 * parameter: {}
 * @param parameter
 * @returns {*}
 */
export function requestDelete (url, param) {
    const data = param ? { params: param } : {}
    return new Promise((resolve, reject) => {
        request
            .delete(url, data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}
/**
 *
 * @param {*} url
 * @param {*} parameter
 * @param {*} method put
 * @returns
 */
export function requestData (url, method, parameter = {}) {
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: method,
            data: parameter
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}
/**
 * post func
 * parameter: {}
 * @param parameter
 * @returns {*}
 */
export function requestPost (url, parameter = {}) {
    return new Promise((resolve, reject) => {
        request({
            url: url,
            method: 'post',
            data: parameter
        })
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}

/**
 * get param func
 * parameter: {}
 * @param parameter
 * @jdy
 * @returns {*}
 */

export function requestGet (url, param) {
    const data = param ? { params: param } : {}
    return new Promise((resolve, reject) => {
        request
            .get(url, data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}
